import * as $ from 'jquery';
import {debounce} from 'lodash';

const failValue = 0;

function indicatePasswordFail($newCode, message) {
    $newCode[0].setCustomValidity(message);
}

function indicatePasswordOk($newCode) {
    $newCode[0].setCustomValidity('');
}

function analysePassword(getQueryData, meterUpdater, requirementer, $newCode) {
    requirementer.clean();

    $.ajax({
        method: 'GET',
        url: window.aalund.locations.analysePassword,
        data: getQueryData(),
        success: function (data) {
            meterUpdater(Number(data.strength));

            requirementer.updateRequirements(data.requirementsMet);

            if (data.fail) {
                indicatePasswordFail($newCode, data.message);
            } else {
                indicatePasswordOk($newCode);
            }
        },
        error: function (jqXHR) {
            if (jqXHR.status === 400) {
                meterUpdater(failValue);
                indicatePasswordFail($newCode, ' ');
            }
        }
    });
}

function validateNewPasswordMatch($newCode, $repeatCode, validityCallback) {
    if ($newCode.val() !== $repeatCode.val()) {
        $repeatCode[0].setCustomValidity(window.aalund.i18n.check_failed);

    } else {
        $repeatCode[0].setCustomValidity('');
    }

    if (typeof validityCallback === 'function') {
        validityCallback($newCode[0].checkValidity() && $repeatCode[0].checkValidity());
    }
}

function updateStrengthIndicator($meter, strength) {
    $meter[0].value = strength;
}

function getQueryData($newCode, $name, $email) {
    return {
        subject: $newCode.val(),
        name: $name.val(),
        email: $email.val()
    };
}

function passwordLeakCheck($newCode, setErrorMessage, validityCallback) {
    $.ajax({
        url: window.aalund.locations.checkForLeaks,
        method: 'GET',
        data: {subject: $newCode.val()},
        success: function (data) {
            if (data.leaked) {
                indicatePasswordFail($newCode, window.aalund.i18n.leaked);
                setErrorMessage(window.aalund.i18n.leaked);

            } else if ($newCode[0].checkValidity()) {
                indicatePasswordOk($newCode);
                setErrorMessage('');
            }

            if (typeof validityCallback === 'function') {
                validityCallback($newCode[0].checkValidity());
            }

        },
        error: function () {
            setErrorMessage(window.aalund.i18n.leaked);
        }
    });
}

class Requirementer
{
    constructor($requirements) {
        this.$requirements = $requirements;
    }

    clean() {
        this.$requirements.each(function () {
            $.default(this).removeClass('requirement-filled');
        });
    }

    updateRequirements(requirementsMet) {
        this.$requirements.each(function () {
            const self = $.default(this),
                requirement = self.attr('data-requirement');

            if (requirementsMet[requirement]) {
                self.addClass('requirement-filled');

            } else {
                self.removeClass('requirement-filled');
            }
        });
    }

    updateRequirement(requirement, state) {
        const $filtered = this.$requirements.filter('*[data-requirement="' + requirement + '"]');

        if (state) {
            $filtered.addClass('requirement-filled');

        } else {
            $filtered.removeClass('requirement-filled');
        }
    }
}

function handleHideRevealPassword() {
    const self = $.default(this),
        $parent = self.parent();
    let $input = $parent.find('input');

    if (!$input.length && $parent.attr('for').length) {
        $input = $.default('#' + $parent.attr('for'));
    }

    if ($parent.hasClass('passwordHidden')) {
        $input.attr('type', 'text');

    } else {
        $input.attr('type', 'password');
    }

    $parent.toggleClass('passwordHidden passwordShown');
}

function resetComponent($newCode, $repeatCode, $meter, $requirementer) {
    $newCode.val('');
    $repeatCode.val('');
    $meter[0].value = 0;
    $requirementer.clean();
    $newCode[0].setCustomValidity('');
    $repeatCode[0].setCustomValidity('');
}

export function setupReset() {
    const $newCode  = $.default('input[name=new_code]'),
        $repeatCode = $.default('input[name=check]'),
        $meter      = $.default('meter'),
        $email      = $.default('input[name="email"]'),
        $name       = $.default('input[name="name"]'),
        requirementer = new Requirementer($.default('*[data-requirement]')),
        $form       = $.default('.login_signInForm_resetForm'),
        setLeakMsg  = function (message) {
            $.default('.login_signInForm_message').html('<p class="error">' + message + '</p>');
        };

    if (!($newCode.length && $repeatCode.length)) {
        return;
    }

    $newCode.focus();
    console.log($meter)

    $newCode.change(validateNewPasswordMatch.bind(null, $newCode, $repeatCode));
    $newCode.keyup(validateNewPasswordMatch.bind(null, $newCode, $repeatCode));
    $newCode.change(passwordLeakCheck.bind(null, $newCode, setLeakMsg));
    $newCode.keyup(debounce(analysePassword.bind(null, getQueryData.bind(null, $newCode, $name, $email), updateStrengthIndicator.bind(null, $meter), requirementer, $newCode), 150));
    $repeatCode.change(validateNewPasswordMatch.bind(null, $newCode, $repeatCode));
    $repeatCode.keyup(validateNewPasswordMatch.bind(null, $newCode, $repeatCode));

    $form.on('click', '*[data-action="revealPassword"], *[data-action="hidePassword"]', handleHideRevealPassword);

    // password comparison between fields
        // add message
    // password leak check
}

export function setupManagedReset($container, validityCallback, setLeakErrorMessage) {
    const $newCode  = $container.find('input[name=new_code]'),
        $repeatCode = $container.find('input[name=check]'),
        $meter      = $container.find('meter'),
        $email      = $container.find('input[name="email"]'),
        $name       = $container.find('input[name="name"]'),
        requirementer = new Requirementer($container.find('*[data-requirement]'));

    if (!($newCode.length && $repeatCode.length)) {
        return;
    }

    $newCode.focus();

    $newCode.change(validateNewPasswordMatch.bind(null, $newCode, $repeatCode, validityCallback));
    $newCode.keyup(validateNewPasswordMatch.bind(null, $newCode, $repeatCode, validityCallback));
    $newCode.change(passwordLeakCheck.bind(null, $newCode, setLeakErrorMessage, validityCallback));
    $newCode.keyup(debounce(analysePassword.bind(null, getQueryData.bind(null, $newCode, $name, $email), updateStrengthIndicator.bind(null, $meter), requirementer, $newCode), 150));
    $repeatCode.change(validateNewPasswordMatch.bind(null, $newCode, $repeatCode, validityCallback));
    $repeatCode.keyup(validateNewPasswordMatch.bind(null, $newCode, $repeatCode, validityCallback));

    $container.on('click', '*[data-action="hidePassword"], *[data-action="revealPassword"]', handleHideRevealPassword);

    return resetComponent.bind(null, $newCode, $repeatCode, $meter, requirementer);
}
